import { light as lightGreen, dark as darkGreen } from './palette--green';
import { light as lightBlue, dark as darkBlue } from './palette--blue';
import { light as lightIndigo, dark as darkIndigo } from './palette--indigo';
import { light as lightPurple, dark as darkPurple } from './palette--purple';
import { light as lightPink, dark as darkPink } from './palette--pink';
import { light as lightOrange, dark as darkOrange } from './palette--orange';
import { light as lightRed, dark as darkRed } from './palette--red';
import { light as lightDaka, dark as darkDaka } from './palette--daka';
import { light as lightCanguro, dark as darkCanguro } from './palette--canguro';
import { light as lightOlive, dark as darkOlive } from './palette--olive';
import { light as lightLegalmente, dark as darkLegalmente } from './palette--legalmente';
import { light as lightPrudence, dark as darkPrudence } from './palette--prudence';
import * as pastelScheme from './palette--pastel';

const palette = (themeMode = 'light', paletteType = 'blue') => {
  let selectedPalette;
  if (paletteType === 'blue') {
    selectedPalette = themeMode === 'dark' ? darkBlue : lightBlue;
  } else if (paletteType === 'purple') {
    selectedPalette = themeMode === 'dark' ? darkPurple : lightPurple;
  } else if (paletteType === 'indigo') {
    selectedPalette = themeMode === 'dark' ? darkIndigo : lightIndigo;
  } else if (paletteType === 'pink') {
    selectedPalette = themeMode === 'dark' ? darkPink : lightPink;
  } else if (paletteType === 'orange') {
    selectedPalette = themeMode === 'dark' ? darkOrange : lightOrange;
  } else if (paletteType === 'red') {
    selectedPalette = themeMode === 'dark' ? darkRed : lightRed;
  } else if (paletteType === 'daka') {
    selectedPalette = themeMode === 'dark' ? darkDaka : lightDaka;
  } else if (paletteType === 'canguro') {
    selectedPalette = themeMode === 'dark' ? darkCanguro : lightCanguro;
  } else if (paletteType === 'olive') {
    selectedPalette = themeMode === 'dark' ? darkOlive : lightOlive;
  } else if (paletteType === 'legalmente') {
    selectedPalette = themeMode === 'dark' ? darkLegalmente : lightLegalmente;
  } else if (paletteType === 'prudence') {
    selectedPalette = themeMode === 'dark' ? darkPrudence : lightPrudence;
  } else if (paletteType === 'pastel') {
    selectedPalette = themeMode === 'dark' ? pastelScheme.dark : pastelScheme.light;
  } else {
    selectedPalette = themeMode === 'dark' ? darkGreen : lightGreen;
  }

  return {
    ...selectedPalette,
    brand: {
      altamiraOlive: '#2B3A1D',
      altamiraOliveDark: '#1F2A15',
      altamiraOliveLight: '#3F542B',
    },
  };
};

export default palette;
